import { useState } from 'react';
import { countryCodeToFlagEmoji, type CountryCode } from '@wapharma/shared';
import { cx } from '../utils/cx.js';
import styles from './PhoneFlag.module.css';

export type PhoneFlagProps = {
  country: CountryCode;
  className?: string;
  /** Accessible name; defaults to ISO code. */
  label?: string;
};

/** Country flag via flagcdn.com; emoji fallback when image fails (e.g. offline). */
export function PhoneFlag({ country, className, label }: PhoneFlagProps) {
  const [imgBroken, setImgBroken] = useState(false);
  const iso = country.toLowerCase();
  const ariaLabel = label ?? country.toUpperCase();

  if (imgBroken) {
    return (
      <span className={cx(styles.flagEmoji, className)} aria-label={ariaLabel} title={ariaLabel}>
        {countryCodeToFlagEmoji(country)}
      </span>
    );
  }

  return (
    <img
      className={cx(styles.flagImg, className)}
      src={`https://flagcdn.com/w40/${iso}.png`}
      alt=""
      width={22}
      height={16}
      loading="lazy"
      decoding="async"
      aria-label={ariaLabel}
      title={ariaLabel}
      onError={() => setImgBroken(true)}
    />
  );
}
